// third-party imports
import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import {
  TypedUseSelectorHook,
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from "react-redux";

// project imports
import rootReducer from "./combineReducer";  // import your combined reducer here

// ==============================|| REDUX - MAIN STORE ||============================== //

// Type the RootState based on the rootReducer
export type RootState = ReturnType<typeof rootReducer>;

// Define AppDispatch type based on the store's dispatch
export type AppDispatch = typeof store.dispatch;

// Create the Redux store
const store = configureStore({
  reducer: rootReducer,
  // explicitly typing the middleware to avoid TypeScript issues
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable state check
      immutableCheck: false,    // Disable immutability check
    }), // Force TypeScript to accept the middleware configuration
});

// Create a persister for Redux persist
const persister = persistStore(store);

// Typed hooks for dispatch and selector
export const useDispatch = () => useReduxDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

// Export store, persister, and dispatch
export const { dispatch } = store;
export { store, persister };

// // third-party imports
// import { configureStore } from "@reduxjs/toolkit";
// import {
//   TypedUseSelectorHook,
//   useDispatch as useReduxDispatch,
//   useSelector as useReduxSelector,
// } from "react-redux";
// import { persistStore } from "redux-persist";

// // project imports
// import rootReducer from "./combineReducer";

// // ==============================|| REDUX - MAIN STORE ||============================== //

// // Type the RootState based on the rootReducer
// export type RootState = ReturnType<typeof rootReducer>;

// // Define AppDispatch type based on the store's dispatch
// export type AppDispatch = typeof store.dispatch;

// // Create the Redux store
// const store = configureStore({
//   reducer: rootReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false, // Disable serializable state check
//       immutableCheck: false, // Disable immutability check
//     }),
// });

// // Create a persister for Redux persist
// const persister = persistStore(store);

// // Typed hooks for dispatch and selector
// export const useDispatch: () => AppDispatch = useReduxDispatch;
// export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

// // Correct export for dispatch
// export const dispatch: AppDispatch = store.dispatch;

// // Export store and persister
// export { store, persister };
